import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// Sprache initial aus der URL ableiten: Liegt der Aufruf unter "/en...",
// starten wir direkt auf Englisch. Sonst ist Deutsch die Standardsprache.
const getUrlLang = (): 'de' | 'en' => {
  if (typeof window === 'undefined') return 'de';
  return window.location.pathname.split('/').includes('en') ? 'en' : 'de';
};

i18n
  .use(initReactI18next)
  .init({
    lng: getUrlLang(),
    fallbackLng: 'de',
    debug: false,
    resources: messages,
    interpolation: { escapeValue: false },
  });

export default i18n;